import { addXtoken } from "@/utils/addToken";
import Quill from "quill";
const EmbedBlot = Quill.import("blots/embed");
import { v4 } from "uuid";

export default class CustomImageBlot extends EmbedBlot {
    static blotName = "image";
    static className = "e-image";
    static tagName = "IMG";
    static create(value: any) {
      let node = super.create();
      if (value?.url) {
        const reg = /^https?:\/\//;
        let src = value.url;
        const isHttp = reg.test(value.url);
        if (isHttp) {
          src = addXtoken(value.url);
        }
        node.setAttribute('src', src);
        node.setAttribute('width', value.width);
        node.setAttribute('height', value.height);
        node.setAttribute('fileName', value.title);
        node.setAttribute('realUrl', value.url);
        node.setAttribute('imageId', v4());
        return node;
      } else {
        node.setAttribute('src', value);
      }
    }
   
    static value(domNode: any) {
      return {
        url: domNode.getAttribute('realUrl'),
        width: domNode.getAttribute('width'),
        height: domNode.getAttribute('height'),
        title: domNode.getAttribute('fileName'),
        imageId: domNode.getAttribute('imageId')
      };
    }
  }
